module.exports = __webpack_public_path__ + "img/Billing.1e26ebf6.svg";